import React, { useEffect } from "react";
import "./SuccessModal.css";
import { Button, Modal } from "react-bootstrap";
import Successfull_Lottie from "../../../Animation/Successfull_Lottie/Successfull_Lottie";

function SuccessModal({ baseLink, ...props }) {

setTimeout(() => {

  props?.onHide()
  
}, 5000);

  return (
    <>
      <section className="SuccessModal modal-holder">
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="SuccessModal modal-holder"
        >
          <Modal.Body>
            <div className="success_main_div">
              <div className="success_loottie_holder">
                <Successfull_Lottie />
              </div>

              <div className="success_content_holder">
                <div className="text_holder">
                  <p className="heading">{props?.successText}</p>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default SuccessModal;
